import Http from "./http";

export const getAiCampaignMembersAPI = (payload) => {
  return Http.post("admin/campaign/members", payload);
};
